import { get } from "lodash";

const phaseList = [
  {
    name: "New Member Questionnaire",
    nameAbbreviation: "NMQ-New",
    statusList: [
      {
        label: "Ready to fill out",
        labelShort: "NMQ Open",
        name: "nmqOpen",
      },
    ],
    text: `<p>The New Member Questionnaire is now hosted on the site <a href="nmq.ochin.org">nmq.ochin.org</a>. Please visit this link to see the organizations responses to the NMQ.</p>`,
  },
  {
    name: "New Member Questionnaire (Historic)",
    nameAbbreviation: "NMQ",
    route: "memberQuestionnaireApp",
    statusList: [
      {
        label: "Ready to fill out",
        labelShort: "NMQ Open",
        name: "nmqOpen",
      },
      {
        label: "Submitted and awaiting approval",
        labelShort: "NMQ Submitted",
        name: "nmqSubmitted",
      },
      {
        label: "Approved and awaiting an install PM",
        labelShort: "NMQ Approved",
        name: "nmqApproved",
      },
    ],
    text: `<p>Thank you for your continued interest in OCHIN! Please complete the New Member Questionnaire (NMQ). The NMQ includes information such as organization background, clinic locations, lab interfaces, information on your billing structure, reporting needs, compliance and HIEs. The NMQ may be filled out by multiple people in your organization – please forward to whomever should be included.</p>
<p>If you have questions or need assistance completing the NMQ, please contact your business development lead or email <a href="businessdevelopment@ochin.org">businessdevelopment@ochin.org</a></p>
<p>Please note this is historic NMQ for sites that have started filling out the New Member Questionnaire before release of new the New Member Questionnaire on June 11th 2024.</p>`,
  },
  {
    name: "Epic Build",
    nameAbbreviation: "Build",
    route: "buildApp",
    statusList: [
      {
        label: "Enter Epic Build Information",
        labelShort: "Build Open",
        name: "buildOpen",
      },
      {
        label: "Completed and imported to Epic",
        labelShort: "Build Closed",
        name: "buildClosed",
      },
    ],
    text:
      "<p>Your install project manager will be reaching out regarding the next steps in the OCHIN install process and introduce your install team. Please work with your install team to complete the following deliverables. The deliverables include additional information regarding the users and structure of your clinics and departments. This section may be filled out by multiple people in your organization – please forward to whomever should be included.</p><p>If you have questions or need assistance completing the Epic Build, please contact your install project manager.</p>",
  },
  {
    name: "Onboarding Complete",
    nameAbbreviation: "Done",
    text: `<p>Your install has been completed! Let's start improving patient outcomes together.</p>`,
    statusList: [
      {
        label: "Nice work!",
        labelShort: "Completed",
        name: "completed",
      },
    ],
  },
];

const statusList = phaseList.reduce(
  (list, phase) => list.concat(phase.statusList),
  []
);

export default {
  getters: {
    getStructureStatus: (state, getters, rootState) => {
      // If any location or department is in an unlocked state, the Organization Structure is considered to be in an unlocked state.
      // Locking and unlocking should only happen via the Structure UI, which locks all departments and locations at once.
      const locationList = get(rootState, "location.list");
      const departmentList = get(rootState, "department.list");

      if (!locationList || !locationList.length) {
        return false;
      }

      const anyLocationIsLocked = locationList.find(
        location => location.locked
      );
      const anyDepartmentIsLocked = departmentList.find(
        department => department.locked
      );

      if (anyLocationIsLocked || anyDepartmentIsLocked) {
        return true;
      }

      return false;
    },
    getStatus: (state, getters, rootState) => {
      const organizationStatus = get(rootState, "organization.record.status");

      const status = state.statusList.find(
        status => status.name === organizationStatus
      );

      return status;
    },
    getLabelShortByStatus: state => organizationStatus => {
      const status = state.statusList.find(
        status => status.name === organizationStatus
      );
      return status.labelShort;
    },
    phaseIsActive: (state, getters, rootState) => phase => {
      const organizationStatus = get(rootState, "organization.record.status");

      if (!organizationStatus) {
        return false;
      }

      return phase.statusList
        .map(status => status.name)
        .includes(organizationStatus);
    },
    phaseIsAvailable: (state, getters, rootState) => phase => {
      const organizationStatus = get(rootState, "organization.record.status");

      if (!organizationStatus) {
        return false;
      }

      const organizationIndex = state.phaseList.findIndex(phase => {
        const nameList = phase.statusList.map(status => status.name);
        const inPhase = nameList.includes(organizationStatus);

        return inPhase;
      });

      const phaseIndex = state.phaseList.findIndex(
        testPhase => testPhase.name === phase.name
      );

      if (organizationIndex === -1 || phaseIndex === -1) {
        return false;
      }

      return organizationIndex >= phaseIndex;
    },
    organizationStatusIndex: (state, getters, rootState) => {
      const status = get(rootState, "organization.record.status");
      const index = getters.statusNameList.indexOf(status);

      return index;
    },
    organizationStatusIsGreaterThanOrEqualTo: (state, getters) => status => {
      const indexStatusOrganization = getters.organizationStatusIndex;
      const indexStatus = getters.statusNameList.indexOf(status);

      return indexStatusOrganization >= indexStatus;
    },
    organizationStatusIsLessThan: (state, getters) => status => {
      const indexStatusOrganization = getters.organizationStatusIndex;
      const indexStatus = getters.statusNameList.indexOf(status);

      return indexStatusOrganization < indexStatus;
    },
    statusNameList: state => state.statusList.map(status => status.name),
    statusNameAndLabelList: state =>
      state.statusList.map(status => {
        return {
          label: status.label,
          labelShort: status.labelShort,
          name: status.name,
        };
      }),
  },
  namespaced: true,
  state: {
    phaseList,
    statusList,
  },
};
